<template>
  <div v-loading="loader">
    <div>
      <el-input
        @input="(s) => searchL(search)"

        placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <draggable
      v-if="(!search && !zoneId) || !isTypeL"
      class="jobs-ul"
      handle=".handle"
      :list="_value"
      @change="change"
    >
      <div
        class="jobs-li" v-for="(option, index) in _value" :key="index" v-show="isShow(option)"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <el-input
            @change="changeOption(option)"
            placeholder="Название" size="mini" v-model="option.label"
            @input="input(option)"/>
        </div>
        <span>
          <i class="fa fa-edit" @click="openEdit(option)"></i>
        </span>
      </div>

    </draggable>

    <draggable
      v-else
      class="jobs-ul"
      handle=".handle"
      :list="searchList"
      @change="change"
    >
      <div
        class="jobs-li" v-for="(option, index) in searchList" :key="index" v-show="isShow(option)"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <el-input placeholder="Название" size="mini" v-model="option.label"
                    @input="input(option)"/>
        </div>
        <span>
          <i class="fa fa-edit" @click="openEdit(option)"></i>
        </span>
      </div>

    </draggable>


    <el-button @click="addOption" style="width: 100%; margin-top: 20px">+ Добавить значение в список</el-button>

    <add-option
      :form="form"
      @remove="remove"
      :dialogVisible="dialogVisible" @close="dialogVisible = false"
      @input="changeOption"
      v-model="optionEdit" :type="type"/>
  </div>
</template>

<script>
import AddOption from "./AddOption";
import draggable from 'vuedraggable';
import {v4 as uuidv4} from "uuid";
import _, {debounce, orderBy} from "lodash";
import CyrillicToTranslit from "cyrillic-to-translit-js";
import firebase from "firebase";
import {addOptionsInputs, addOptionsInputsWithoutResponse} from "../../../firestore/inputs";

export default {
  props: {
    value: Array,
    type: String,
    zoneId: String,
    form: Object
  },
  data() {
    return {
      loader: false,
      dialogVisible: false,
      optionEdit: null,
      search: '',
      options: [],
      searchList: [],
      searchListSave: [],
      newValues: []
    }
  },
  name: "OptionList",
  components: {AddOption, draggable},
  watch: {
    zoneId: {
      async handler() {
        this.fetchZone()
      },
      immediate: true
    },
    dialogVisible(d) {
      if (!d) {
        this.changeOption(this.optionEdit)
      }
    }
  },
  beforeDestroy() {
    if (this.newValues.length && this.isTypeL) {
      addOptionsInputsWithoutResponse(this.$store.state.project.id, this.form.id, this.updateIndexes(this.newValues))
    }
    return
  },
  methods: {
    updateIndexes(array) {
      let sortedIndexes = array.map(item => item.index).sort((a, b) => a - b);
      let lastIndex = -1;

      // Перебираем массив и обновляем индексы, проверяя на дубликаты
      array.forEach((item, index) => {
        if (sortedIndexes[index] <= lastIndex) {
          item.index = lastIndex + 1;
        } else {
          item.index = sortedIndexes[index];
        }
        lastIndex = item.index;
      });

      return array
    },
    input(option) {
      option.value = option.label
      this.changeOption(option)
    },
    changeOption(option) {
      if (!this.isTypeL) {
        return
      }

      const index = this.newValues.findIndex(({uid}) => option.uid === uid)

      if (index === -1) {
        if (!option.isDelete) {
          this.newValues.push(option)
        }
      } else {
        if (!option.isDelete) {
          this.newValues[index] = option
        }
      }

      console.log(this.newValues, 'NEW VALUEs')
    },
    async fetchZone() {
      if (!this.isTypeL) {
        return
      }
      if (!this.zoneId) {
        return
      }

      this.loader = true
      let resp = []
      const query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .doc(this.$route.params.id)
        .collection('optionsList')
        .orderBy('index', 'asc')
        .where('zoneId', '==', this.zoneId)


      resp = await query.limit(100).get()

      const result = []
      resp.forEach((d) => {
        result.push(
          {
            id: d.id,
            ...d.data(),
            isCreate: true,
          }
        )
      })

      this.searchList = [...orderBy(result, 'index', 'asc')]
      this.loader = false;
    },
    change(d) {
      if (this.zoneId) {
        addOptionsInputs(this.$store.state.project.id, this.$route.params.id, this.updateIndexes(this.searchList))
      }
      this.$emit('change', d)
    },
    searchL: debounce(async function (search) {

      if (this.isTypeL) {
        this.loader = true;

        let resp = null


        if (search && search.length) {
          const cyrillicToTranslit = new CyrillicToTranslit();

          const txt = String(cyrillicToTranslit.transform(search).toLowerCase())
          const txtArray = txt.split(' ')

          if (this.zoneId) {
            resp = await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('inputs')
              .doc(this.$route.params.id)
              .collection('optionsList')
              .where('zoneId', '==', this.zoneId)
              .where('searchName', 'array-contains', txtArray[txtArray.length - 1])
              .limit(100).get()
          } else {
            resp = await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('inputs')
              .doc(this.$route.params.id)
              .collection('optionsList')
              .where('searchName', 'array-contains', txtArray[txtArray.length - 1])
              .limit(100).get()
          }
        } else {

          resp = []
          if (this.zoneId) {
            return this.fetchZone()
          }
        }

        const result = []
        resp.forEach((d) => {
          result.push(
            {
              id: d.id,
              ...d.data(),
              isCreate: true,
            }
          )
        })

        this.searchList = [...orderBy(result.filter(({label}) => label.toLowerCase().includes(search.toLowerCase()) || !search), 'index', 'asc')]
        this.searchListSave = JSON.parse(JSON.stringify(this.searchList))
        this.loader = false;
      } else {
        this.searchList = [...orderBy(this._value.filter(({label}) => label.toLowerCase().includes(search.toLowerCase()) || !search), 'index', 'asc')]
      }

    }, 500),

    isShow(option) {
      if (!this.zoneId && !option.zoneId) {
        return true
      }

      return !!(this.zoneId && this.zoneId === option.zoneId);
    },
    remove(option) {
      this.dialogVisible = false
      this._value = [...this._value.filter((o) => o.uid !== option.uid)]
      this.searchList = [...this.searchList.filter((o) => o.uid !== option.uid)]
      // this.newValues = [...this.newValues.filter((o) => o.uid !== option.uid)]

    },
    openEdit(option) {
      this.dialogVisible = true;
      this.optionEdit = option;
    },
    async getLastIndex() {
      const resp = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .doc(this.$route.params.id)
        .collection('optionsList')
        .orderBy('index', 'desc')
        .where('zoneId', '==', this.zoneId)
        .limit(1).get()

      const result = []
      resp.forEach((d) => {
        result.push(
          {
            id: d.id,
            ...d.data(),
            isCreate: true,
          }
        )
      })

      if (result.length) {
        return result[0]
      }
      return null
    },
    async addOption() {
      if (!Array.isArray(this._value)) {
        this._value = []
      }

      let details = {
        1: this.form.defaultFields["1"] || '',
        2: this.form.defaultFields["2"] || '',
        3: this.form.defaultFields["3"] || '',
        4: this.form.defaultFields["4"] || '',
        5: this.form.defaultFields["5"] || ''
      }

      if (this.type === 'nomenclature') {
        details = {
          1: this.form.defaultFields["1"] || '',
          2: this.form.defaultFields["2"] || '',
          3: this.form.defaultFields["3"] || '',
          4: this.form.defaultFields["4"] || '',
          5: this.form.defaultFields["5"] || '',
          6: this.form.defaultFields["6"] || '',
          7: this.form.defaultFields["7"] || '',
          8: this.form.defaultFields["8"] || '',
          9: this.form.defaultFields["9"] || '',
          10: this.form.defaultFields["10"] || ''
        }
      }
      let index = 0

      if (this.isTypeL) {
        const IndexData = await this.getLastIndex();


        if (IndexData) {
          const options = this.form.options.filter(({isCreate}) => !isCreate).length
          const searchOptions = this.searchList.filter(({isCreate}) => !isCreate).length
          index = IndexData.index + searchOptions + options
        }
      } else {
        index = this.form.options.length + 1
      }


      const option = {
        label: '',
        value: '',
        zoneId: this.zoneId || null,
        uid: uuidv4(),
        details,
        index
      }

      this._value.push(option)
      this.searchList.push(option)
    },
  },
  computed: {
    isTypeL() {
      return this.form && this.form.type && (this.form.type.value.includes('L') || this.form.type.value === 'nomenclature')
    },
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    .name {
      display: flex;
      align-items: center;

      .fa-align-justify {
        margin-right: 20px;
      }
    }

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
<style lang="scss">
.jobs-create {
  .el-loading-mask {
    position: relative !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/OptionList.vue